import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75adaf76"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "weight-management",
  class: "section-weight-management"
}
const _hoisted_2 = { class: "section-inner" }
const _hoisted_3 = { class: "video-wrap gif-container" }
const _hoisted_4 = { class: "html-embed w-embed" }
const _hoisted_5 = { class: "video-mask" }
const _hoisted_6 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Text = _resolveComponent("Text")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Text, {
        class: "section-copy",
        eyebrow: _ctx.$t('home.weightManagement.eyebrow'),
        header: _ctx.formattedHeader,
        content: _ctx.formattedDesc,
        linkcont: _ctx.$t('home.weightManagement.button'),
        link: "info",
        textAlign: "end"
      }, null, 8, ["eyebrow", "header", "content", "linkcont"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _ctx.demo,
              alt: _ctx.$t('home.weightManagement.imageAlt'),
              class: "demo-image"
            }, null, 8, _hoisted_6)
          ])
        ])
      ])
    ])
  ]))
}